import React from 'react';
import { styled } from '@mui/material/styles';
import { Theme, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { CustomTabsProps } from './customTabsProps';
import { TabItem } from './tabItem';

const Root = styled(Tabs)(({ theme }: { theme: Theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  marginBottom: '25px',
  minWidth: '72px',
  padding: '1px 2px',
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
  },
  '& .MuiTabs-scrollButtons': {
    backgroundColor: theme.palette.primary.main,
  },
}));

const StyledTab = styled(Tab)(({ theme }: { theme: Theme }) => ({
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
  },
}));

const CustomTabs: React.FC<CustomTabsProps> = ({
  selectedTab,
  handleTabChange,
  isKit,
  tabs,
  style,
  isResponsive,
}) => {
  const theme = useTheme();
  const allTabs = isKit ? [...tabs, { id: tabs.length + 1, label: 'Kit Items' }] : tabs;

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (newValue >= 0 && newValue < allTabs.length) {
      const selectedTabId = allTabs[newValue].id;
      handleTabChange(selectedTabId);
    }
  };

  const selectedIndex = allTabs.findIndex((tab) => tab.id === selectedTab);
  const value = selectedIndex !== -1 ? selectedIndex : 0;

  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isXLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
  const maxWidth = isXLargeScreen
    ? '470px'
    : isLargeScreen
    ? '360px'
    : '100%';

  return (
    <Root
      value={value}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      style={{
        maxWidth: isResponsive ? maxWidth : '',
        ...style,
      }}
    >
      {allTabs.map((tab: TabItem) => (
        <StyledTab key={tab.id} label={tab.label} />
      ))}
    </Root>
  );
};

export default CustomTabs;
